import React, { useEffect, useRef } from 'react';

// Extracted from Homepage.js (was a local component there) so the new
// standalone marketing pages can fade in on scroll with the exact same
// motion language, instead of each reimplementing its own observer.
let _revealObs = null;
const getRevealObs = () => {
  if (!_revealObs && typeof IntersectionObserver !== 'undefined') {
    const isMob = typeof window !== 'undefined' && window.innerWidth < 768;
    _revealObs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        el.classList.add('nx-visible');
        _revealObs.unobserve(el);
        const onDone = (ev) => {
          if (ev.target !== el) return;
          el.style.willChange = 'auto';
          el.removeEventListener('transitionend', onDone);
        };
        el.addEventListener('transitionend', onDone);
      }),
      { threshold: isMob ? 0.18 : 0.05 }
    );
  }
  return _revealObs;
};

const useRevealRef = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = getRevealObs();
    if (!obs) return;
    obs.observe(el);
    return () => obs.unobserve(el);
  }, []);
  return ref;
};

export const REVEAL_CSS = `
  .nx-reveal{opacity:0;transform:translateY(24px) scale(.97);transition:opacity .5s cubic-bezier(.16,1,.3,1),transform .5s cubic-bezier(.16,1,.3,1);will-change:opacity,transform}
  .nx-reveal.nx-visible{opacity:1;transform:translateY(0) scale(1)}
  @media (max-width: 760px){
    .nx-reveal{transition-duration:1.4s,1.4s;transition-property:opacity,transform;transform:translateY(16px)}
    .nx-reveal.nx-visible{transform:translateY(0)}
  }
  @media (prefers-reduced-motion: reduce){
    .nx-reveal{opacity:1;transform:none;transition:none}
  }
`;

const Reveal = ({ children, className = '', delay = 0, style = {} }) => {
  const ref = useRevealRef();
  return (
    <div ref={ref} className={`nx-reveal ${className}`} style={{ transitionDelay: `${delay}ms`, ...style }}>
      {children}
    </div>
  );
};

export default Reveal;
